// 路由映射表
import { Navigate } from "react-router-dom";
import Login from "../pages/Login";
import Layout from "../layouts/BasicLayout";
import { lazy } from "react";
import ProtectedRoute from "./ProtectedRoute";
import RedirectRoute from "./RedirectRoute";
import CommentManage from "@/pages/commentManage/CommentManage";
const WorkSpace = lazy(
  () => import("../pages/WorkSpace/index"), // 工作台
);
const AccountManagement = lazy(
  () => import("../pages/AccountManagement/index"), // 账号管理
);
const SubordInateAgent = lazy(
  () => import("../pages/SubordinateAgent/index"), // 下级代理
);
const CustomerManagement = lazy(
  () => import("../pages/CustomerManagement/index"), //  客户管理
);
const CustomerProtection = lazy(
  () => import("../pages/CustomerProtection/index"), //  客户保护
);
const AccountAuth = lazy(() => import("../pages/AccountAuth/index")); // 账号授权
const Material = lazy(() => import("../pages/Material/index")); // 素材管理
const TemplatePage = lazy(() => import("../pages/Material/TemplatePage/index")); // 素材模板
const FinancialStatement = lazy(() => import("../pages/FinancialStatement/index")); // 财务流水
const RechargeStatement = lazy(() => import("../pages/RechargeStatement/index")); // 充值流水
const CaseQuery = lazy(() => import("../pages/CaseQuery/index")); // 案例查询
const VideoPage = lazy(() => import("../pages/PublishManage/VideoPage/index")); // 视频页面
const ImagePage = lazy(() => import("../pages/PublishManage/ImagePage/index")); // 图文页面
const VideoTemplate = lazy(() => import("../pages/Material/VideoTemplate/index")); // 视频模板
const ImageTemplate = lazy(() => import("../pages/Material/ImageTemplate/index")); // 图文模板
const MessageManage = lazy(() => import("../pages/messageManage/MessageManage")) //私信管理
const routers = [
  {
    path: "/",
    element: <Navigate to="/work-space" />,
  },
  {
    path: "/",
    element: (
      <RedirectRoute>
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      </RedirectRoute>
    ),
    /**
     * @description children: 路由配置子集
     * @description path: 对应的路由path
     * @description element: 对应的路由组件
     * @description meta: meta信息，用于Route的meta信息
     */
    children: [
      {
        path: "/work-space",
        element: <WorkSpace />, // 工作台
      },
      {
        path: "/account-management",
        element: <AccountManagement />, // 账号管理
      },
      {
        path: "/subord-inateAgent",
        element: <SubordInateAgent />, // 下级代理
      },
      {
        path: "/customer-management",
        element: <CustomerManagement />, // 客户管理
      },
      {
        path: "/customer-protection",
        element: <CustomerProtection />, // 客户保护
      },
      {
        path: "/account-auth",
        element: <AccountAuth />, // 账号授权
      },
      {
        path: "/material/index",
        element: <Material />, // 素材管理
      },
      {
        path: "/material/template/:id",
        element: <TemplatePage />,
      },
      {
        path: "/material/video/:id",
        element: <VideoTemplate />, // 视频模板
      },
      {
        path: "/material/image/:id",
        element: <ImageTemplate />, // 图文模板
      },
      {
        path: "/financial-statement",
        element: <FinancialStatement />, // 财务流水
      },
      {
        path: "/recharge-statement",
        element: <RechargeStatement />, // 充值流水
      },
      {
        path: "/case-query",
        element: <CaseQuery />, // 充值流水
      },
      {
        path: "/publish/video",
        element: <VideoPage />, // 视频管理
      },
      {
        path: "/publish/image",
        element: <ImagePage />, // 图文管理
      },

      {
        path: '/service/message',
        element: <MessageManage />,
      },
      {
        path: '/service/comment',
        element: <CommentManage />,

      }
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
];
export default routers;
